import { AuthedAxiosRequests } from 'features/auth'

interface HhutFileMetadata {
  component: string
  date: string
  x_offset: number
  y_offset: number
  x_unit: string
  y_unit: string
  inspection?: string
  job: string
  parserType: string
  binWidth?: number
  binHeight?: number
}

/**
 * Function to upload an HHUT file and its metadata to the Risk Calculator service for creating a HHUT inspection and CDS
 * @param file - The file to upload, it should be an 'XLSX' formatted Excel file
 * @param metaData - The metadata to associate with the file
 * @param riskCalculatorURl - The URL of the risk calculator API
 * @param axios - The axios instance to use for the request
 * @returns The response from the risk calculator API
 * @param riskCalculatorURl
 * @param axios
 * @returns
 */
export const uploadFileAndMetaData = async (
  file: File,
  metaData: HhutFileMetadata,
  riskCalculatorURl: string,
  axios: AuthedAxiosRequests
) => {
  const formData = new FormData()
  formData.append('file', file)
  const stringifiedMetaData = JSON.stringify(metaData)
  formData.append('metaData', stringifiedMetaData)

  return axios.post(`${riskCalculatorURl}/hhut/uploadFileAndMetadata`, formData)
}
